// Permission check helpers (Phase 1: navigation gating).
// 4-level pages + the dashboard on/off tab map (see backend/routes/roles.py).
export const can = (user, page, level) => {
  if (!user) return false;
  if (user.username === "admin") return true;
  if (user.permissions?.settings?.master === true) return true;
  return user.permissions?.[page]?.[level] === true;
};

// Vehicles module sub-page keys — mirrors the backend catalogue.
export const VEHICLES_PAGE_KEYS = [
  "vehicles_renault_vehicle",
  "vehicles_renault_customer",
  "vehicles_renault_insurance",
  "vehicles_renault_dates_programs",
  "vehicles_renault_documents",
  "vehicles_renault_dealer",
  "vehicles_otherbrands_vehicle",
  "vehicles_otherbrands_customer",
  "vehicles_otherbrands_insurance",
  "vehicles_otherbrands_dates_programs",
  "vehicles_otherbrands_documents",
];

// Vehicle-aware check with the Master cascade: master on ANY sub-page within
// a group (Renault / Other Brands) grants every level on EVERY sub-page of
// that same group. The cascade never crosses groups. Master on a sub-page
// also satisfies its own lower levels. Backend enforces the same rule.
export const canVehicle = (user, key, level) => {
  if (can(user, key, level)) return true;
  const prefix = key.startsWith("vehicles_otherbrands_")
    ? "vehicles_otherbrands_"
    : "vehicles_renault_";
  return VEHICLES_PAGE_KEYS.filter((k) => k.startsWith(prefix)).some(
    (k) => user?.permissions?.[k]?.master === true
  );
};

// True when the user can view at least one Vehicles sub-page (cascade-aware).
export const canAnyVehicles = (user) =>
  VEHICLES_PAGE_KEYS.some((key) => canVehicle(user, key, "view"));

// Customer Relations check — master on a page satisfies every level on that
// same page (mirrors the Vehicles convention). Backend enforces the same rule.
export const canCR = (user, page, level) =>
  can(user, page, level) || can(user, page, "master");

// CR stage page key for an appointment date:
// past → history, today → today, tomorrow/future → upcoming.
export const apptStagePage = (dateStr, todayStr) => {
  if (!dateStr || dateStr === todayStr) return "today";
  return dateStr < todayStr ? "history" : "upcoming";
};
